var _defs, _g, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishedGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bagGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d0f0ff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b0dff5",
    stopOpacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14h28v36c0 2-1.5 4-4 4H22c-2.5 0-4-2-4-4V14z",
    fill: "url(#bagGrad)",
    stroke: "#a0c4d8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12h28v36c0 2-1.5 4-4 4H20c-2.5 0-4-2-4-4V12z",
    fill: "url(#bagGrad)",
    stroke: "#90b4c8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10h28v36c0 2-1.5 4-4 4H18c-2.5 0-4-2-4-4V10z",
    fill: "url(#bagGrad)",
    stroke: "#80a4b8",
    strokeWidth: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#ffffff",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedGood);
export default __webpack_public_path__ + "static/media/finished-good.b4426189d377c2d746e04a163d37fef7.svg";
export { ForwardRef as ReactComponent };